import { tss } from 'tss-react/mui';

export const useCtaStyles = tss.withName('CtaSection').create(({ theme }) => ({
    section: {
        backgroundColor: theme.palette.ink.main,
        color: theme.palette.ink.contrastText,
        padding: theme.spacing(16, '6%'),
        textAlign: 'center',
    },
    inner: {
        maxWidth: 800,
        margin: '0 auto',
    },
    eyebrow: {
        color: theme.palette.primary.main,
        display: 'block',
        marginBottom: theme.spacing(3),
    },
    headline: {
        marginBottom: theme.spacing(5),
    },
}));
